import React, { ReactNode } from 'react';
import { I } from '../icons-ds';

export type MobileNavProps = {
  title?: string;
  backTitle?: string;
  onBack?: () => void;
  action?: ReactNode;
  large?: boolean;
  transparent?: boolean;
  sticky?: boolean;
};

export function MobileNav({
  title,
  backTitle,
  onBack,
  action,
  large = true,
  transparent,
  sticky = true,
}: MobileNavProps) {
  // Only render the top bar row when it holds something (a back button or an
  // action, or a compact non-large title). On a large-title screen with neither,
  // we skip it so the big title sits flush under the status bar — no blank row.
  const showCompactRow = !large || Boolean(onBack) || Boolean(action);
  return (
    <div
      className="dp-mobile-nav"
      style={{
        position: sticky ? 'sticky' : 'relative', top: 0, zIndex: 30,
        paddingTop: sticky ? 'env(safe-area-inset-top, 0px)' : 0,
        background: transparent ? 'transparent' : 'var(--bg-translucent)',
        backdropFilter: transparent ? 'none' : 'saturate(1.8) blur(20px)',
        WebkitBackdropFilter: transparent ? 'none' : 'saturate(1.8) blur(20px)',
        borderBottom: transparent ? 'none' : '0.5px solid var(--line-divider)',
      }}
    >
      {showCompactRow && (
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: 8, padding: '0 12px',
          height: 'var(--nav-h-mobile)',
        }}
      >
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          {onBack && (
            <button
              onClick={onBack}
              aria-label={backTitle || 'Back'}
              style={{
                minHeight: 44, minWidth: 44,
                display: 'inline-flex', alignItems: 'center', gap: 0,
                color: 'var(--accent)', fontSize: 17, fontWeight: 400,
                padding: '6px 6px 6px 0',
                background: 'transparent', border: 0, cursor: 'pointer',
              }}
            >
              <I.chevL size={22} stroke={2.2} />
              {backTitle && <span style={{ marginLeft: -2 }}>{backTitle}</span>}
            </button>
          )}
        </div>
        {!large && <div
          style={{
            fontSize: 17, fontWeight: 600, letterSpacing: '-0.4px',
          }}
        >
          {title}
        </div>}
        <div
          style={{
            flex: 1, display: 'flex', justifyContent: 'flex-end',
            color: 'var(--accent)',
          }}
        >
          {action}
        </div>
      </div>
      )}
      {large && (
        <div style={{ padding: showCompactRow ? '2px 16px 12px' : '10px 16px 12px' }}>
          <div
            style={{
              fontSize: 34, fontWeight: 700, letterSpacing: '-0.6px', lineHeight: 1.1,
            }}
          >
            {title}
          </div>
        </div>
      )}
    </div>
  );
}

export default MobileNav;
